export default __webpack_public_path__ + "static/media/internet.9ce39f60.jpg";